export default __webpack_public_path__ + "static/media/dropdown-menu-arrow.e791eb99.svg";